import { StarsButton } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import IcnStandard from '@swf/core/assets/casino/icnStandard.jpg';
import useRequest from '@swf/core/hooks/useRequest';
import { getState, select } from '@swf/core/store';
import type { CasinoGame } from '@swf/core/types/CasinoGame';
import type { GameTypesAndVariants } from '@swf/core/types/Notification';

import Grid from '../Grid';

import { TXTCLI_Next, TXTCLI_Previous } from './EligibleGames.messages.json';
import styles from './EligibleGames.scss';
import { getCasinoGamesQuery } from './EligibleGamesUtility';

const EligibleGames: React.FC<{ eligibleGameData: GameTypesAndVariants[] }> = ({
  eligibleGameData
}) => {
  const [eligibleGames, setEligibleGames] = useState<CasinoGame[]>([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const pageSize = 45;
  const request = useRequest();

  useEffect(() => {
    const qry = [getCasinoGamesQuery(eligibleGameData)];
    setIsFetching(true);
    setEligibleGames([]);
    request<CasinoGame[]>({
      service: 'casino.games.all',
      ...select.cms.getRequestOptions(getState()),
      body: {
        pg: pageNumber,
        qry,
        grp: true,
        ims: { tags: ['icnStandard'] },
        psz: pageSize
      }
    }).subscribe(({ body }) => {
      setIsFetching(false);
      if (body.length > 0) {
        setEligibleGames(body);
      }
    });
  }, [eligibleGameData, pageNumber, request]);

  return (
    <>
      <Grid>
        {eligibleGames.map((g, i) => (
          <div className={styles.gameItemWrapper} key={i}>
            <img
              className={styles.gameGridImage}
              alt={g.name}
              src={g.images.icnStandard || IcnStandard}
            />
            {!g.images.icnStandard && <div className={styles.gameItemText}> {g.name} </div>}
          </div>
        ))}
      </Grid>
      <ButtonGroup>
        {eligibleGames.length >= pageSize && (
          <StarsButton
            translation={TXTCLI_Next}
            onClick={() => setPageNumber(pageNumber + 1)}
            disabled={isFetching}
          />
        )}
        {pageNumber > 0 && (
          <StarsButton
            translation={TXTCLI_Previous}
            onClick={() => setPageNumber(pageNumber - 1)}
            variant="secondary"
            disabled={isFetching}
          />
        )}
      </ButtonGroup>
    </>
  );
};

export default EligibleGames;
